
import axios from 'axios'
import {mask} from "vue-the-mask"
import tooltips from '@/utilities/tooltips.js'
import * as common from "@/common.js"
import {forceCorrectDate} from "@/common.js"
import * as spaApi from "@/spaApi.js"
import loading from '@/components/PageLoader'
import moment from 'moment'

axios.defaults.headers.common['Pragma'] = 'no-cache';

export default {
  components: {
    loading,
  },
  directives: {},
  computed: {
    moment() {
      return moment
    },
    showUserDropdown(){
      return this.groupBy.value === 'User' && this.userOptions.length > 1;
    }

  },
  data() {
    return {
      monthYears: [],
      selectedMonthYear: null,
      breadcrumbs: [
        {text: this.$t("UsageStatistics"), active: true}
      ],
      isLoading: false,
      groupBy: null,
      groupByOptions: [
        {text: this.$t('BusinessUnit'), value: 'BusinessUnit'},
        {text: this.$t('User'), value: 'User'}
      ],
      activityType: null,
      activityTypeOptions: [
        {text: this.$t('CompletedIntegration'), value: 'CompletedIntegration'},
        {text: this.$t('OpenedIntegration'), value: 'OpenedIntegration'},
        {text: this.$t('All'), value: 'All'}
      ],
      selectedBusinessUnit: null,
      businessUnitOptions: [{ display: 'All Business Units', businessUnit: null}],
      selectedUser: null,
      userOptions:  [{ display: 'All Users', user: null}],
      stats: [],
      statsFields: [{ key: 'monthYear', label: 'Time Period'}, { key: 'statisticsForName', label: 'Business Unit'}, {key: 'destination'}, {key: 'activityType'}, {key: 'activityCount'}]
    }
  },
  watch: {},
  mounted() {},
  created() {
    this.loadMonthYears();
    this.groupBy = this.groupByOptions[0];
    this.activityType = this.activityTypeOptions[0];
    this.selectedBusinessUnit = this.businessUnitOptions[0];
    this.selectedUser = this.userOptions[0];

  },
  methods: {
    loadMonthYears(){
      spaApi.getMonthsWithStatistics(this.monthYearsLoaded);
    },
    monthYearsLoaded(data){
      const list = [];
      data.forEach((x)=>{
        const displayVal = x.substring(4,6) + '/' + x.substring(0,4);

        list.push({
          "text": displayVal,
          "value": x
        });
      });

      this.monthYears = list;
      this.selectedMonthYear = list[list.length-1];
      this.loadBusinessUnits();
      this.loadStats();
    },
    timePeriodChanged(){
      this.loadStats();
    },
    loadStats(){
      spaApi.getUsageStats(this.selectedMonthYear.value, this.groupBy.value, this.activityType.value, this.selectedBusinessUnit.businessUnit, this.selectedUser.user, this.statsLoaded);
    },
    loadBusinessUnits(){
      spaApi.getBusinessUnits(this.selectedMonthYear.value, this.businessUnitsLoaded)
    },
    businessUnitsLoaded(data){
      if(data != null){
        this.businessUnitOptions = data;
        this.selectedBusinessUnit = this.businessUnitOptions[0];
      }
    },
    businessUnitChanged(){
       this.loadStats();
    },
    loadUsers(){
      spaApi.getUsersForBusinessUnit(this.selectedMonthYear.value, this.selectedBusinessUnit.businessUnit, this.usersLoaded)
    },
    usersLoaded(data){
      if(data != null){
        this.userOptions = data;
      }
    },
    userChanged(){
      this.loadStats()
    },
    statsLoaded(data){
      if(data != null){
        this.stats = data;
      }
      this.isLoading = false;
    },
    groupByChanged(){
      this.setFields();
      if(this.groupBy.value === 'User'){
        //For now we're not segregating users by business unit.
        this.selectedBusinessUnit = this.businessUnitOptions[0];
        this.loadUsers();
      }else{
        this.selectedUser = this.userOptions[0];
      }
      this.loadStats();
    },
    activityTypeChanged(){
      this.loadStats()
    },
    setFields(){
      if(this.groupBy.value === 'BusinessUnit'){
        this.statsFields =  [{ key: 'monthYear', label: 'Time Period'}, { key: 'statisticsForName', label: 'Business Unit'}, {key: 'destination'}, {key: 'activityType'}, {key: 'activityCount'}];
      }else{
        this.statsFields =  [{ key: 'monthYear', label: 'Time Period'}, { key: 'statisticsForName', label: 'User'}, {key: 'destination'}, {key: 'activityType'}, {key: 'activityCount'}]
      }
    }

  }
}
